export type PlatformFeatureFlagKey =
  | 'propertyMap'
  | 'classifieds'
  | 'giftCards'
  | 'aiListing'
  | 'propertyListings'
  | 'businessDirectory'
  | 'homePlatformStats'
  | 'homeShopByParish'
  /** When false, vendors are not blocked on hub for unsigned vendor-agreement. */
  | 'vendorAgreementGate';

export type PlatformFeatureFlags = Record<PlatformFeatureFlagKey, boolean>;

export const PLATFORM_FEATURE_FLAG_KEYS: PlatformFeatureFlagKey[] = [
  'propertyMap',
  'classifieds',
  'giftCards',
  'aiListing',
  'propertyListings',
  'businessDirectory',
  'homePlatformStats',
  'homeShopByParish',
  'vendorAgreementGate',
];

export const PLATFORM_FEATURE_FLAG_LABELS: Record<PlatformFeatureFlagKey, string> = {
  propertyMap: 'Property map view',
  classifieds: 'Classifieds marketplace',
  giftCards: 'Gift certificates',
  aiListing: 'AI shop assistant',
  propertyListings: 'Property listings',
  businessDirectory: 'Business directory',
  homePlatformStats: 'Homepage — platform stats bar',
  homeShopByParish: 'Homepage — shop by location',
  vendorAgreementGate: 'Require vendor agreement (hub & Connect)',
};

export const DEFAULT_PLATFORM_FEATURE_FLAGS: PlatformFeatureFlags = {
  propertyMap: true,
  classifieds: true,
  giftCards: true,
  aiListing: true,
  propertyListings: true,
  businessDirectory: true,
  homePlatformStats: false,
  homeShopByParish: true,
  vendorAgreementGate: true,
};
